import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { saveState } from 'modules/storage';

const saveThunk = () => {
    return (dispatch, getState) => {
        const state = getState();
        saveState({ map: state.map });
    };
};

export const SaveMapStateOnUnload = () => {
    const dispatch = useDispatch();
    const save = () => dispatch(saveThunk());

    useEffect(() => {
        window.addEventListener('beforeunload', save);
        return () => {
            window.removeEventListener('beforeunload', save);
        };
    }, []); // eslint-disable-line

    return null;
};
